import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ThemeModule } from '@app/@theme/theme.module';
import { NbCheckboxModule, NbDialogModule, NbWindowModule } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { LanguageSelectComponent } from './components';
import { ClearInputComponent } from './components/clear-input/clear-input.component';
import { DishImagesTemplatesComponent } from './components/dish-images-templates/dish-images-templates.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { IsGivenOutCheckboxComponent } from './components/is-given-out-checkbox';
import { LegendChartComponent } from './components/legend-chart/legend-chart.component';
import { LangReadyDirective } from './directives';
import { ClearInputDirective } from './directives/clear-input.directive';

import {
  IsRequiredFieldPipe
} from './pipes';

const EXPORTED_PIPES = [
  IsRequiredFieldPipe
];

const EXPORTED_DIRECTIVES = [
  LangReadyDirective,
  FileUploaderComponent,
  DishImagesTemplatesComponent,
  ClearInputDirective
];

const EXPORTED_COMPONENTS = [
  LanguageSelectComponent,
  FileUploaderComponent,
  DishImagesTemplatesComponent,
  ClearInputComponent,
  LegendChartComponent,
  //IsGivenOutCheckboxComponent
];

@NgModule({
  declarations: [...EXPORTED_PIPES, ...EXPORTED_DIRECTIVES, ...EXPORTED_COMPONENTS],
  imports: [
    ThemeModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NbCheckboxModule,
    NbDialogModule.forChild(),
    NbWindowModule.forChild()
  ],
  exports: [
    ...EXPORTED_PIPES, 
    ...EXPORTED_DIRECTIVES,
    ...EXPORTED_COMPONENTS,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [  ]
})
export class CoreUIModule {
  static forRoot(): ModuleWithProviders<CoreUIModule> {
    return <ModuleWithProviders<CoreUIModule>>{
      ngModule: CoreUIModule,
      providers: []
    };
  }
}
